import { formatGemNumber } from '../../helper.js';
import { hexToRgb } from '../../services.js';
import Show from '../../utility/Show.jsx';

const ProgressBar = ({ items, scores, itemClick, state }) => {
  const { isExploreEnabled, isMobile } = state;
  const totalScore = scores
    ? Object.values(scores).reduce((acc, score) => acc + score, 0)
    : 0;

  // Calculate percentage width, handle case where totalScore is 0 and apply minimum width if needed
  const getPercentage = (value = 1) => {
    if (totalScore === 0) return 100 / items.length;
    const percentage = (value / totalScore) * 100;
    return percentage < 10 ? 10 : percentage; // Minimum width is 10%
  };

  return (
    <div className="bar-score-container flex flex-col md:flex-row">
      {/* Bar Container */}
      <div className="gems-bar">
        {items.map((item) => (
          <div
            key={item.id}
            className="gems-bar-container"
            style={{
              width: `${getPercentage(scores?.[item.id]) || 10}%`,
              '--icon-color': hexToRgb(item.color),
            }}
            onClick={() => itemClick(item.name, false)}
          >
            <div className="bar-section">
              <span className="bar-score">{totalScore === 0 ? 0 : scores[item.id] || 0}</span>
            </div>
            {item.svg}
            <Show.When isTrue={!isMobile}>
              <span className="bar-label">{item.name}</span>
            </Show.When>
          </div>
        ))}
      </div>
      <div className="total-score">
        <strong>{formatGemNumber(totalScore)}</strong> <span>Total</span>
      </div>
    </div>
  );
};

export default ProgressBar;
